import React from 'react';
import { Link } from 'react-router-dom';
import { Clock } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';

const BlogPreviewCard = ({ blog, hideDescription = false }) => {
  return (
    <Link
      to={`/blogs/${blog.slug || blog._id}`}
      className="group flex items-start space-x-3 p-3 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors border-b border-gray-100 dark:border-gray-700 last:border-0"
    >
      {/* Small Image */}
      <div className="flex-shrink-0 w-20 h-20 sm:w-24 sm:h-24 rounded overflow-hidden bg-gray-200 dark:bg-gray-700">
        <img
          src={blog.thumbnail}
          alt={blog.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          onError={(e) => {
            e.target.src = 'https://via.placeholder.com/200x200?text=Blog';
          }}
        />
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <span className="text-xs font-medium text-accent mb-1 block">
          {blog.category}
        </span>
        <h3 className="font-heading font-semibold text-heading dark:text-white mb-1 line-clamp-2 group-hover:text-accent transition-colors text-sm sm:text-base">
          {blog.title}
        </h3>
        {!hideDescription && blog.excerpt && (
          <p className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 line-clamp-2 mb-2">
            {blog.excerpt}
          </p>
        )}
        <div className="flex items-center text-xs text-gray-500 dark:text-gray-500">
          <Clock className="w-3 h-3 mr-1" />
          <span>
            {blog.publishedAt
              ? formatDistanceToNow(new Date(blog.publishedAt), { addSuffix: true })
              : formatDistanceToNow(new Date(blog.createdAt), { addSuffix: true })}
          </span>
        </div>
      </div>
    </Link>
  );
};

export default BlogPreviewCard;
